import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurksAndCaicosIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1281)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9679 12H12C12 11.9892 12 11.9787 12 11.9679C11.9893 11.9786 11.9786 11.9893 11.9679 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78638 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47444 6.26086H12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.071 1.56522C4.19417 2.63392 2.63384 4.1942 1.56519 6.07103V12H4.69564V4.69576V4.69567H12C12 3.70834 12 2.76775 12 1.56522H6.071Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 10.5243L7.73649 6.26093H6.26086V6.26102L11.9999 12H12C12 12 12 10.9825 12 10.5243Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 6.26086V12C13.5652 14.7956 17.2174 15.6522 17.2174 15.6522C17.2174 15.6522 20.8695 14.7956 20.8695 12V6.26086H13.5652Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6957 8.34784C16.6957 8.92416 16.2285 10.4348 15.6522 10.4348C15.0759 10.4348 14.6087 8.92416 14.6087 8.34784C14.6087 7.77151 15.6522 7.30435 15.6522 7.30435C15.6522 7.30435 16.6957 7.77151 16.6957 8.34784Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.4646 9.48432C19.633 9.07346 19.764 8.4729 19.764 8.17393C19.764 7.69365 19.1379 7.30435 19.1379 7.30435C19.1379 7.30435 18.5118 7.6937 18.5118 8.17393C18.5118 8.4729 18.6427 9.07346 18.8111 9.48432L18.4496 10.3004C18.6621 10.3868 18.8943 10.4348 19.1378 10.4348C19.3813 10.4348 19.6136 10.3868 19.826 10.3004L19.4646 9.48432Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4348 12C16.4348 12 15.9131 13.0435 15.9131 14.087H18.5218C18.5217 13.0435 18 12 18 12L17.2174 11.4783L16.4348 12Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 12V11.7391C18 11.3069 17.6496 10.9565 17.2174 10.9565C16.7852 10.9565 16.4348 11.3069 16.4348 11.7391V12H18Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1281",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTurksAndCaicosIslands;
